module.exports = __webpack_public_path__ + "img/vertical_layout_5.0bf28b1e.png";